<div fxLayout="row wrap" fxLayoutAlign="start center" >
  <div fxLayout="row" fxLayoutAlign="start center" class="joint-button-container" *ngFor="let articleId of item.cells[fieldDefinition.key]?.value">
    <a class="pointer" (click)="viewArticle(articleId.split(':')[0])">{{articleId.split(':')[1]}}</a>
  </div>
</div>
